module.exports = __webpack_public_path__ + "img/hero.8c1948f0.png";